import { useState } from 'react';
import { BadgeNotification } from './BadgeNotification';
import type { Badge } from '../services/conceptPlus1Service';

interface MultiBadgeNotificationProps {
  badges: Badge[];
  onClose: () => void;
}

export function MultiBadgeNotification({ badges, onClose }: MultiBadgeNotificationProps) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleCurrentClose = () => {
    if (currentIndex < badges.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      onClose();
    }
  };

  if (badges.length === 0) return null;

  return <BadgeNotification badge={badges[currentIndex]} onClose={handleCurrentClose} />;
}
